module.exports = __webpack_public_path__ + "static/example-image-5-47dce8bb644fdc4a90b7eca6579b331c.jpg";